import "./ChartSection.scss";
import { useEffect, useState } from "react";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import { Background, TokenomicsEffect } from "@images";
// import { Background } from "@images";

function ChartSection() {

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  const isMobile = width <= 768;

  function tooltip() { 
    return `<div class="tooltip-info">
    <h2 class="percentage">{value.percent}%</h2>
    <p class="label">{category}</p>
    <div class="date">
      <div class="lock-icon"></div>
        <p>{date}</p>
      </div>
  </div>`;
  }

  useEffect(() => {
    var chart = am4core.create("chartdiv", am4charts.PieChart3D);
    chart.innerRadius = am4core.percent(37);
    chart.angle = 40;
    chart.resizable = true;
   
    // Add data
    chart.data = [{
      "label": "DAO Governance Sale",
      "value": 100,
      "color": am4core.color("#fbcac7"),
      "date": "until March 1, 2023"
    },{
      "label": "Team",
      "value": 100,
      "color": am4core.color("#fff5b8"),
      "date": "until March 1, 2023"
    },{
      "label": "Ecosystem Development",
      "value": 400,
      "color": am4core.color("#8ce0a9"),
      "date": "until March 1, 2023"
    },{
      "label": "10 Year User Data Pool",
      "value": 400,
      "color": am4core.color("#9ea8ff"),
      "date": "until March 1, 2023"
    }];

    chart.depth = 70;

    // Add and configure Series
    const pieSeries = chart.series.push(new am4charts.PieSeries3D());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "label";
    pieSeries.slices.template.strokeWidth = 2;
    pieSeries.slices.template.strokeOpacity = 1;
    pieSeries.labels.template.disabled = false;
    pieSeries.ticks.template.disabled = true;
    pieSeries.slices.template.propertyFields.fill = "color";


    pieSeries.labels.template.html = tooltip();
    // pieSeries.labels.template.disabled = true;
    pieSeries.slices.template.adapter.add("tooltipHTML", function(tooltipHTML, target) {
      // #2: If we had used an event, here you would work on the target itself, event.target, not the template.
      // The showHtml might not even be needed, perhaps whatever it does can go in here instead.
      return tooltip();
    });

    if (isMobile) {
      chart.radius = 45;
      chart.innerRadius = am4core.percent(50);
      chart.depth = 40;
      chart.responsive.enabled = true;
    } else {
      var initialDepthVal = 0;
      pieSeries.slices.template.events.on("over", function(event){
        if (!initialDepthVal) {
          initialDepthVal = event.target.depth;
        }
        event.target.depth = initialDepthVal + 40;
      });
      pieSeries.slices.template.events.on("out", function(event){
        event.target.depth = initialDepthVal;
      });
    }
  }, [])

  return (
      <div className="chart-section">
          <img className="tokonomics-effect" src={TokenomicsEffect} alt="" />

          <div className="section-title">
            <p className='subtitle'>1 Billion $SKIN Tokens Distributed Over 10 years</p>
            <h2 className='title'>Meaningful Tokenomics</h2>
          </div>


          <div className="chart-container">
            {/* <div className="tooltip-container">
              <div className="tooltip-info">
                <h2 className="percentage">40%</h2>
                <p className="label">DAO Governance Sale  </p>
                <div className="date">
                  <div className="lock-icon"></div>
                    <p>until March 1, 2023</p>
                  </div>
              </div>
            </div> */}
            <div id="chartdiv" style={{ width: "100%", height: "500px" }}></div>
          </div>

        

          <p className="desc-txt">
            Please note $SKIN is not a financial asset or holds any value. $SKIN represents a tokenized governance vote for the Skin DAO project. We make no warranties or representations regarding value, tradeability or ongoing viability of the project. Please be careful with your recovery seed within Skin DAO app, if you lose your keys we cannot recover your account. Buying $SKIN is not available for US or Canadian users.
          </p>
      </div>
  );
}

export default ChartSection;
